import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M15 0H1v4H0v1.2h1v3.2H0v1.2h1v3.2H0V14h1v4h14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm.8 16c0 .441-.359.8-.8.8H2.2V14H3v-1.2h-.8V9.6H3V8.4h-.8V5.2H3V4h-.8V1.2H15c.441 0 .8.359.8.8v14zm-3.98-5.576a3.49 3.49 0 0 0-1.45-.89L9.004 10.9 7.636 9.531a3.51 3.51 0 0 0-1.457.892c-.163.168-.288.37-.376.588L5 13h8l-.804-1.989a1.808 1.808 0 0 0-.376-.587zm-2.816-1.66c1.089 0 1.551-1.021 1.551-1.937 0-.951-.454-1.841-1.551-1.841s-1.56.881-1.56 1.841c0 .942.454 1.937 1.56 1.937z" />
  </svg>
);

export default SvgComponent;
